import * as React from "react";
const SvgFiRrBuildingNgo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-building-ngo_svg__a)">
      <path
        fill="#062147"
        d="M16 10v9c0 2.757-2.243 5-5 5H5c-2.757 0-5-2.243-5-5L.007 4.872c0-2.37 1.909-4.737 3.928-4.87a1.01 1.01 0 0 1 1.063.933 1 1 0 0 1-.933 1.063c-.899.06-2.059 1.463-2.059 2.874L1.999 19c0 1.654 1.346 3 3 3h6c1.654 0 3-1.346 3-3v-9a1 1 0 1 1 2 0zM4 11a1 1 0 0 0 1 1h1a1 1 0 1 0 0-2H5a1 1 0 0 0-1 1m7-1h-1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2m-5 4H5a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2m5 0h-1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2m-5 4H5a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2m5 0h-1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2M21.5 0A2.5 2.5 0 0 0 19 2.5v3a2.5 2.5 0 1 0 5 0v-3A2.5 2.5 0 0 0 21.5 0m.9 5.5c0 .496-.404.9-.9.9a.9.9 0 0 1-.9-.9v-3c0-.496.404-.9.9-.9s.9.404.9.9zm-6.9-1.25c0 .414.336.75.75.75h.15v.468c0 .48-.361.898-.838.93A.9.9 0 0 1 14.6 5.5V2.53c0-.435.296-.826.722-.912a.85.85 0 0 1 .726.184.8.8 0 0 0 .519.198h.062c.721 0 1.068-.894.528-1.372A2.5 2.5 0 0 0 15.481 0C14.098.01 13 1.175 13 2.558v2.886C13 6.846 14.147 8.026 15.548 8A2.5 2.5 0 0 0 18 5.5V4.25a.75.75 0 0 0-.75-.75h-1a.75.75 0 0 0-.75.75M10.4.8v3.263L8.855.577A.968.968 0 0 0 7 .97V7.2a.8.8 0 1 0 1.6 0V3.946l1.544 3.478A.97.97 0 0 0 12 7.03V.8a.8.8 0 1 0-1.6 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-building-ngo_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBuildingNgo;
